/*
  Функция, которая получает json с сервера
*/

export default function getJson(path, token = ""){
  return async (setData, setError) => fetch(
    path, 
    {
      "method": "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token
      } 
    }
  ).then(
    data => {
      if (data.ok) {
        return data.json().then(setData)
      } else return data.json().then(setError)
    }
  )
} 